import {
  signUpRequest,
  checkEmailExistedRequest,
  checkUserMolliePromotedRequest,
  updateMerchantContactRequest,
  uploadIbanKycRequest,
  createMollieBankRequest,
  updatePasswordRequest,
  getMeRequest,
  saveKycDocument,
  merchantSignIn,
} from "./MerchantAction"

export const MerchantAction = {
  signUpRequest,
  checkEmailExistedRequest,
  checkUserMolliePromotedRequest,
  updateMerchantContactRequest,
  createMollieBankRequest,
  uploadIbanKycRequest,
  getMeRequest,
  updatePasswordRequest,
  saveKycDocument,
  merchantSignIn
}
